function SetVh() {
	let vh = window.innerHeight * 0.01;

	function setVertHeight() {
		vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	setVertHeight();

	let resizeTimer;

	function onResize() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => setVertHeight(), 150);
	}

	window.addEventListener('resize', onResize);

	return () => {
		clearTimeout(resizeTimer);
		window.removeEventListener('resize', onResize);
	};
}

export default SetVh;
